<form
  class="position-relative d-flex flex-column gap-3"
  [formGroup]="device_form"
  [tds-data-loader]="{ key: 'devices-creation-form', as_overlay: true, delay: 500 }"
  (ngSubmit)="createDevice()"
>
  <div>
    <label for="productCategory" class="form-label required">
      {{ 'product_category' | translate }}
    </label>
    <select
      id="productCategory"
      class="form-select cursor-pointer"
      formControlName="category"
      [class.is-invalid]="isFieldValid('category')"
      [required]="true"
      [attr.aria-describedby]="isFieldValid('category') ? 'categoryValidationFeedback' : undefined"
    >
      <option value="">{{ 'select' | translate }}</option>
      <option *ngFor="let category of device_characteristics.category" [value]="category.id">
        {{ category.name }}
      </option>
    </select>
    <div
      *ngIf="isFieldValid('category')"
      id="categoryValidationFeedback"
      class="invalid-feedback d-block"
    >
      {{ 'choose_a_product_category' | translate }}
    </div>
  </div>

  <div>
    <label for="deviceBrand" class="form-label required">{{ 'brand' | translate }}</label>
    <select
      id="deviceBrand"
      class="form-select cursor-pointer"
      formControlName="brand"
      [class.is-invalid]="isFieldValid('brand')"
      [required]="true"
      [attr.aria-describedby]="isFieldValid('brand') ? 'brandValidationFeedback' : undefined"
    >
      <option value="">{{ 'select' | translate }}</option>
      <option *ngFor="let brand of device_characteristics.brand" [value]="brand.id">
        {{ brand.name }}
      </option>
    </select>
    <div
      *ngIf="isFieldValid('brand')"
      id="brandValidationFeedback"
      class="invalid-feedback d-block"
    >
      {{ 'choose_a_brand' | translate }}
    </div>
  </div>

  <div>
    <label for="deviceModel" class="form-label required">
      {{ 'model' | translate }}
    </label>
    <select
      id="deviceModel"
      class="form-select cursor-pointer"
      formControlName="model"
      [class.is-invalid]="isFieldValid('model')"
      [required]="true"
      [attr.aria-describedby]="isFieldValid('model') ? 'modelValidationFeedback' : undefined"
    >
      <option value="">{{ 'select' | translate }}</option>
      <option *ngFor="let model of device_characteristics.model" [value]="model.id">
        {{ model.name }}
      </option>
    </select>
    <div
      *ngIf="isFieldValid('model')"
      id="modelValidationFeedback"
      class="invalid-feedback d-block"
    >
      {{ 'choose_a_model' | translate }}
    </div>
  </div>

  <div>
    <label for="deviceColor" class="form-label required">
      {{ 'color' | translate }}
    </label>
    <select
      id="deviceColor"
      class="form-select cursor-pointer"
      formControlName="color"
      [class.is-invalid]="isFieldValid('color')"
      [required]="true"
      [attr.aria-describedby]="isFieldValid('color') ? 'colorValidationFeedback' : undefined"
    >
      <option value="">{{ 'select' | translate }}</option>
      <option *ngFor="let color of device_characteristics.color" [value]="color.id">
        {{ color.name }}
      </option>
    </select>
    <div
      *ngIf="isFieldValid('color')"
      id="colorValidationFeedback"
      class="invalid-feedback d-block"
    >
      {{ 'choose_a_color' | translate }}
    </div>
  </div>

  <div>
    <label for="deviceStorage" class="form-label required">
      {{ 'storage' | translate }}
    </label>
    <select
      id="deviceStorage"
      class="form-select cursor-pointer"
      formControlName="storage"
      [class.is-invalid]="isFieldValid('storage')"
      [required]="true"
      [attr.aria-describedby]="isFieldValid('storage') ? 'storageValidationFeedback' : undefined"
    >
      <option value="">{{ 'select' | translate }}</option>
      <option *ngFor="let storage of device_characteristics.storage" [value]="storage.id">
        {{ storage.name }}
      </option>
    </select>
    <div
      *ngIf="isFieldValid('storage')"
      id="storageValidationFeedback"
      class="invalid-feedback d-block"
    >
      {{ 'choose_a_storage_size' | translate }}
    </div>
  </div>

  <div>
    <label for="deviceImei" class="form-label required">
      {{ 'imei' | translate }}
    </label>
    <input
      id="deviceImei"
      class="form-control"
      type="text"
      formControlName="imei"
      restrict-input="no_empty_space"
      [class.is-invalid]="isFieldValid('imei')"
      [required]="true"
      [attr.aria-describedby]="isFieldValid('imei') ? 'imeiValidationFeedback' : undefined"
    />
    <div id="imeiValidationFeedback" *ngIf="isFieldValid('imei')" class="invalid-feedback d-block">
      <span *ngIf="device_form.controls['imei'].errors!['required']">
        {{ 'choose_an_imei' | translate }}
      </span>
      <span *ngIf="device_form.controls['imei'].errors!['error']">
        {{ device_form.controls['imei'].errors!['error'] }}
      </span>
    </div>
  </div>

  <div>
    <label for="deviceSerialNumber" class="form-label required">
      {{ 'serial_number' | translate }}
    </label>
    <input
      id="deviceSerialNumber"
      class="form-control"
      type="text"
      formControlName="serial_number"
      restrict-input="no_empty_space"
      [class.is-invalid]="isFieldValid('serial_number')"
      [required]="true"
      [attr.aria-describedby]="
        isFieldValid('serial_number') ? 'serialNumberValidationFeedback' : undefined
      "
    />
    <div
      *ngIf="isFieldValid('serial_number')"
      id="serialNumberValidationFeedback"
      class="invalid-feedback d-block"
    >
      <span *ngIf="device_form.controls['serial_number'].errors!['required']">
        {{ 'choose_a_serial_number' | translate }}
      </span>
      <span *ngIf="device_form.controls['serial_number'].errors!['error']">
        {{ device_form.controls['serial_number'].errors!['error'] }}
      </span>
    </div>
  </div>

  <button class="btn btn-primary w-100" type="submit" [disabled]="device_form.invalid">
    {{ 'continue' | translate }}
  </button>
</form>
